import type { GameRow } from '../types';
import type { UsFullGameTotalTarget } from '@/lib/polymarketUs/totalTarget';

/**
 * #1030 — the Game Detail row for an exact native US full-game total reopened
 * from a saved order or holding (the Tracker). A total row (`|total|`) whose
 * typed threshold is the native line, full game. It carries no K/P books: the
 * board row it is built from is the game's moneyline, never this total.
 */
/**
 * #1030 — a row built by `usTotalPanelGame`: a native US total with no K/P
 * books. Only such a row's two team slots are the native sides (Over, Under).
 * A K/P total row carries its Over book in both slots, so on US its slot never
 * picks Under: YES is Over there, as on Kalshi and Polymarket.
 */
export function isUsOnlyTotalRow(game: GameRow): boolean {
  return game.key.includes('|total|pmus-') && !game.kalshi && !game.polymarket;
}

export function usTotalPanelGame(base: GameRow, target: UsFullGameTotalTarget): GameRow {
  const line = Number(target.line);
  return { ...base, key: `${base.key}|total|pmus-${target.marketSlug}`,
    awayName: `Over ${target.line}`, homeName: `Under ${target.line}`,
    kalshi: null, polymarket: null, spreadOutcome: undefined, finalWinnerSide: null,
    totalOutcome: { line, period: 'full', kalshiTicker: null, polymarketTicker: null } };
}
